import React, { useState, useEffect } from "react";
import { format } from 'date-fns';
import { Cita } from "../../types/cita";
import { fetchUsers, postCita } from "../../services/General/citaServiceGraph";
import { citaUser } from "../../types/citaUser";
import { useAuth } from "../../context/AuthContext";
import UserSearch from "../shared/UserSearchGraph";
import { getPersonaVetadaByCedula } from "../../services/General/personaVetadaService";
//import PersonaSearch from "../shared/PersonaSearchPicker";
import PersonaSearchSQL from "../shared/PersonaSearch";
// Importa la librería Quill para el editor de texto enriquecido
import ReactQuill from 'react-quill'; // Importa el componente de Quill
import 'react-quill/dist/quill.snow.css'; // Importa el CSS de Quill si lo necesitas
import DOMPurify from "dompurify";
import { Building } from "../../types/building";
import { fetchBuildings } from "../../services/Administracion/buildingsService";
import AcompanantesModal from "./AcompanantesModal";
import Swal from "sweetalert2";
import { formatDate, getCurrentDateTimeLocal, isDateNotInPast, getMinEndDate } from "../../utils/fechaUtil";
import { PersonaVetada } from "../../types/personaVetada";
import { PersonaSQL } from "../../types/PersonaSQL";
import  CreatePersonaModal  from '../shared/CrearPersonaModal';



const CitaForm = () => {
    const { user } = useAuth();
    const [form, setForm] = useState<Cita>({
        //id: null,
        host_email: user?.User.email || "",
        guest_email: "",
        cc_email: "",
        guest_cedula: "",
        guest_name: "",
        start_date: "",
        indications: "",
        office_Location: "",
        end_date: "",
        user: user?.User.email || "",
        is_active: true,
        building_id: null,
        acompanantes: [],
    });
    const [loading, setLoading] = useState(false);
    const [loadingEdificios, setLoadingEdificios] = useState(false);
    const [impersonar, setImpersonar] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<string | null>(null);
    const [canImpersonate, setCanImpersonate] = useState(false);
    const [isContentValid, setIsContentValid] = useState(true);
    const [showUserSearch, setShowUserSearch] = useState(false);
    const [buildings, setBuildings] = useState<Building[]>([]);
    const [resetKey, setResetKey] = useState(0); //para resetear el componente de quill
    const [personaVetada, setPersonaVetada] = useState<{
        vetado: boolean;
        cedula?: string;
        nombre?: string;
        motivo?: string;
        creadoPor?: string;
    }>({ vetado: false });

    const [acompanantesOpen, setAcompanantesOpen] = useState(false);
    const [showCreatePersonaModal, setShowCreatePersonaModal] = useState(false);
    const [pendingSearchQuery, setPendingSearchQuery] = useState('');
    const [personaSearchResetKey, setPersonaSearchResetKey] = useState(0);


    const quillModules = {
        toolbar: [
            [{ 'header': [1, 2, false] }], // Cambia el tamaño del encabezado
            ['bold', 'italic', 'underline', 'strike'], // Formato de texto
            ['blockquote', 'code-block'], // Bloque de cita y bloque de código
            // ['link', 'image'], // Enlace e imagen
            [{ 'list': 'ordered' }, { 'list': 'bullet' }], // Listas ordenadas y desordenadas
            ['clean'] // Botón para limpiar el formato
        ], // Se Puede agregar más módulos de Quill aquí si se necesita
    };
    const quillFormats = [
        'header', 'bold', 'italic', 'underline', 'strike', 'blockquote',
        'code-block', 'list', 'bullet'
        // 'code-block', 'link', 'image', 'list', 'bullet'
    ];

    // Agrega estos estados
    const [emailErrors, setEmailErrors] = useState({
        hostEmail: false,
        guestEmail: false,
        ccEmail: false,
    })


    const handleContentChange = (content: string) => {
        const cleanContent = DOMPurify.sanitize(content, {
            ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'br', 'ul', 'ol', 'li', 'blockquote', 'code', 'h1', 'h2', 'h3'],
            ALLOWED_ATTR: ['href', 'target'],
        });

        setForm(prev => ({
            ...prev,
            indications: cleanContent
        }));
        if (cleanContent.trim() !== '') {
            setIsContentValid(cleanContent.length >= 20);
        } else {
            setIsContentValid(true); // No mostrar error si está vacío
        }
    };

    const calcularHoraFin = (startDate: string, horas: number = 1) => {
        if (!startDate) return "";

        const start = new Date(startDate);
        start.setHours(start.getHours() + horas);

        const pad = (num: number) => num.toString().padStart(2, '0');

        console.log("Fecha de fin:", `${start.getFullYear()}-${pad(start.getMonth() + 1)}-${pad(start.getDate())}T${pad(start.getHours())}:${pad(start.getMinutes())}`);
        return `${start.getFullYear()}-${pad(start.getMonth() + 1)}-${pad(start.getDate())}T${pad(start.getHours())}:${pad(start.getMinutes())}`;

    }
    const handleAcompanantesChange = (acompanantes: any[]) => {
        setForm(prev => ({
            ...prev,
            acompanantes
        }));
    };

    //Maneja el cambio de fecha y hora
    const handleFechaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = e.target.value;
        const nuevaFechaFin = calcularHoraFin(newDate, 1); // Asigna la hora de fin automáticamente
        setForm(prev => ({
            ...prev,
            start_date: newDate,
            end_date: nuevaFechaFin // Asigna la hora de fin automáticamente
        }));
    };

    const handleFechaFinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newEndDate = e.target.value;
        const startDate = new Date(form.start_date);
        const endDate = new Date(newEndDate);
        if (endDate.getTime() - startDate.getTime() < 3600000) { // 1 hora en milisegundos
            return;
        }
        setForm(prev => ({
            ...prev,
            end_date: newEndDate
        }));
    }

    const handleUserSelect = (user: citaUser) => {
        setForm(prev => ({
            ...prev,
            host_email: user.mail,
            office_Location: user.officeLocation || "", // Asigna la ubicación si está disponible
        }));
        setShowUserSearch(false);
    };

    // Manejador para cuando no se encuentra la persona
    const handlePersonaNotFound = (query: string) => {
        setPendingSearchQuery(query); //Guarda el texto que uso el usuario
        setShowCreatePersonaModal(true); //Abre el modal
    };

    // Manejador para cuando se crea exitosamente una persona
    const handlePersonaCreada = async (nuevaPersona: PersonaSQL) => {
        // La misma lógica que handlePersonaSelect pero sin verificar veto
        const nombreCompleto = `${nuevaPersona.nombre} ${nuevaPersona.apellido1} ${nuevaPersona.apellido2}`.trim();
        
        setForm(prev => ({
            ...prev,
            guest_cedula: nuevaPersona.identificador,
            guest_name: nombreCompleto
        }));

        setPersonaSearchResetKey(prev => prev + 1);

        // Mostrar mensaje de éxito
        Swal.fire({
            title: '¡Persona creada!',
            text: `${nombreCompleto} ha sido agregada al sistema`,
            icon: 'success',
            timer: 2000
        });

        // Opcional: verificar si está vetada (aunque recién creada no debería)
        // pero podrías dejarlo por si acaso
        setPersonaVetada({ vetado: false });
    };


    const handlePersonaSelectSQL = async (persona: PersonaSQL | null) => {

        console.log('Persona en handlePersonaSQL', persona);
        if (!persona) {
            console.log('Persona en nulo')
            // Usuario limpió la selección
            setForm(prev => ({
                ...prev,
                guest_cedula: '',
                guest_name: '',
                guest_email: prev.guest_email
            }));
            setPersonaVetada({ vetado: false });
            setError(null);
            return;
        }

        // Construir nombre completo
        const nombreCompleto = `${persona.nombre} ${persona.apellido1} ${persona.apellido2}`.trim();

        // Asignar inmediatamente los valores al formulario
        setForm(prev => ({
            ...prev,
            guest_cedula: persona.identificador,
            guest_name: nombreCompleto,
            guest_email: prev.guest_email // mantener el email actual
        }));
        setError(null);

        try {
            // Verificar si la persona está vetada (el servicio espera cédula)
            const personaVetada: PersonaVetada | null = await getPersonaVetadaByCedula(persona.identificador);
            console.log('resultado de persona vetada: ', personaVetada);

            if (personaVetada && personaVetada.veto_id && personaVetada.is_active) {
                setPersonaVetada({
                    vetado: true,
                    cedula: personaVetada.cedula,
                    nombre: personaVetada.nombre,
                    motivo: personaVetada.motivo,
                    creadoPor: personaVetada.created_by
                });

                Swal.fire({
                    title: '¡Persona Vetada! ⚠️',
                    html: `...`, // tu HTML actual
                    icon: 'error',
                    confirmButtonText: 'Limpiar y buscar otra persona',
                    confirmButtonColor: '#3085d6',
                    showCancelButton: true,
                    cancelButtonText: 'Cerrar',
                    cancelButtonColor: '#d33',
                    allowOutsideClick: false,
                    width: '500px',
                    customClass: { popup: 'border border-danger' }
                }).then((result) => {
                    if (result.isConfirmed) {
                        limpiarSeleccionPersona();
                    }
                });

                setError(`No se puede agendar cita. ${nombreCompleto} está vetado(a).`);
                return;
            }

            // Si NO está vetada
            setPersonaVetada({ vetado: false });
        } catch (error: any) {
            // Manejo de errores (igual que antes)
            if (error.response?.status === 404) {
                setPersonaVetada({ vetado: false });
            } else {
                Swal.fire({
                    title: 'Error de conexión',
                    text: 'No se pudo verificar el estado de la persona. Por favor, intente nuevamente.',
                    icon: 'warning'
                });
            }
        }
    };


    // const handlePersonaSelect = async (persona: any) => {
    //     // PRIMERO: Asignar inmediatamente los valores al formulario
    //     setForm(prev => ({
    //         ...prev,
    //         guest_cedula: persona.CEDULA,
    //         guest_name: persona.NOMBRE,
    //         guest_email: prev.guest_email // Mantener el email actual
    //     }));
    //     setError(null);
    //     try {
    //         //Verificiar si la persona está vetada ANTES de asignar los datos al form
    //         const personaVetada: PersonaVetada | null = await getPersonaVetadaByCedula(persona.CEDULA);
    //         console.log('resultado de persona vetada: ', personaVetada);
    //         //Verificar si hay veto activo
    //         if (personaVetada && personaVetada.veto_id && personaVetada.is_active) {
    //             setPersonaVetada({
    //                 vetado: true,
    //                 cedula: personaVetada.cedula,
    //                 nombre: personaVetada.nombre,
    //                 motivo: personaVetada.motivo,
    //                 creadoPor: personaVetada.created_by
    //             })

    //             // Mostrar alerta de error usando SweetAlert2
    //             Swal.fire({
    //                 title: '¡Persona Vetada! ⚠️',
    //                 html: `
    //                     <div class="text-start">
    //                         <p><strong>${persona.NOMBRE}</strong></p>
    //                         <p>Cédula: <strong>${persona.CEDULA}</strong></p>
    //                         <hr class="my-2">
    //                         <p class="mb-1"><strong>Motivo del veto:</strong></p>
    //                         <p class="text-danger mb-2">${personaVetada.motivo}</p>
    //                         <p class="mb-1"><strong>Vigente desde:</strong> ${new Date(personaVetada.fecha_desde).toLocaleDateString('es-ES')}</p>
    //                         ${personaVetada.observaciones ? `
    //                             <p class="mb-1"><strong>Observaciones:</strong></p>
    //                             <p class="fst-italic">${personaVetada.observaciones}</p>
    //                         ` : ''}
    //                     </div>
    //                 `,
    //                 icon: 'error',
    //                 confirmButtonText: 'Limpiar y buscar otra persona',
    //                 confirmButtonColor: '#3085d6',
    //                 showCancelButton: true,
    //                 cancelButtonText: 'Cerrar',
    //                 cancelButtonColor: '#d33',
    //                 allowOutsideClick: false,
    //                 width: '500px',
    //                 customClass: {
    //                     popup: 'border border-danger'
    //                 }
    //             }).then((result) => {
    //                 if (result.isConfirmed) {
    //                     limpiarSeleccionPersona();
    //                 }
    //             });
    //             // También mostrar un mensaje debajo del campo
    //             setError(`No se puede agendar cita. ${persona.NOMBRE} está vetado(a).`);
    //             return; // Detener la ejecución aquí
    //         }
    //         // Si NO está vetada, proceder normalmente
    //         setPersonaVetada({ vetado: false });
    //     } catch (error: any) {
    //         console.error('Error al verificar persona vetada:', error);
    //         // Si el error es 404 o array vacío (persona no encontrada en vetados)
    //         if (error.response?.status === 404) {
    //             // Persona NO está vetada, proceder normalmente
    //             setForm(prev => ({
    //                 ...prev,
    //                 guest_cedula: persona.CEDULA,
    //                 guest_name: persona.NOMBRE
    //             }));
    //             setError(null);
    //         } else {
    //             // Otro tipo de error (problema de conexión, etc.)
    //             Swal.fire({
    //                 title: 'Error de conexión',
    //                 text: 'No se pudo verificar el estado de la persona. Por favor, intente nuevamente.',
    //                 icon: 'warning'
    //             });
    //             // Aún así, permitir seleccionar la persona (mejor permitir que falle en el backend)
    //             setForm(prev => ({
    //                 ...prev,
    //                 guest_cedula: persona.CEDULA,
    //                 guest_name: persona.NOMBRE
    //             }));
    //         }
    //     }
    // };

    // Función para construir el mensaje
    
    const generateIndications = (guestEmail: string, guestName: string | null, location: string) => {
        if (!guestEmail || !guestName) return '';
        return `Favor presentarse en la oficina ${location} y traer su cédula de identidad.`;
    };


    const handleIndicationsFocus = () => {
        if (form.guest_email && form.guest_name && form.office_Location) {
            const generatedContent = generateIndications(form.guest_email, form.guest_name, form.office_Location);
            setForm(prevForm => ({
                ...prevForm,
                indications: generatedContent,
            }));
            setIsContentValid(generatedContent.length >= 20);
        }
    };

    const resetForm = () => {
        setForm({
            host_email: user?.User.email || "",
            guest_email: "",
            guest_cedula: "",
            guest_name: "",
            cc_email: "",
            start_date: "",
            indications: "",
            office_Location: "",
            end_date: "",
            user: user?.User.email || "",
            is_active: true,
            building_id: null,
            acompanantes: [],
        });
        setIsContentValid(true); // Resetear validación
        setEmailErrors({ hostEmail: false, guestEmail: false, ccEmail: false }); // Resetear errores de email
        setError(null); // Limpiar errores anteriores
        setSuccess(null);
        // Para forzar re-render de ReactQuill
        setResetKey(prev => prev + 1);
        setAcompanantesOpen(false);
    };


    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        if (!form.guest_cedula?.trim() || !form.guest_name?.trim()) {
            setError('Debe seleccionar una persona para la cita');
            setLoading(false);
            return;
        }

        // NUEVO: Validar emails de acompañantes
        if (form.acompanantes && form.acompanantes.length > 0) {
            const emailsInvalidos = form.acompanantes
                .filter(acomp => acomp.email && !validateEmail(acomp.email));

            if (emailsInvalidos.length > 0) {
                setError(`Algunos acompañantes tienen emails no válidos: ${emailsInvalidos.map(a => a.nombre).join(', ')}`);
                setLoading(false);
                return;
            }
        }
        // Validar persona vetada
        if (personaVetada.vetado) {
            setError(`No se puede agendar cita para ${personaVetada.nombre} porque está vetado(a).`);
            Swal.fire({
                title: '¡Persona Vetada! ⚠️',
                html: `
                        <div class="text-start">
                            <p><strong>${personaVetada.nombre}</strong></p>
                            <p>Cédula: <strong>${personaVetada.cedula}</strong></p>
                            <hr class="my-2">
                            <p class="mb-1"><strong>Motivo del veto:</strong></p>
                            <p class="text-danger mb-2">${personaVetada.motivo}</p>
                        </div>
                    `,
                icon: 'error',
                confirmButtonText: 'Entendido !',
                confirmButtonColor: '#3085d6',
                allowOutsideClick: false,
                width: '500px',
                customClass: {
                    popup: 'border border-danger'
                }
            });
            setLoading(false);
            return;
        }

        // Validar usando función del utilitario
        if (!isDateNotInPast(form.start_date)) {
            setError(`No se puede agendar una cita en el pasado. 
                    Fecha actual: ${formatDate(new Date())}
                    Fecha intentada: ${formatDate(form.start_date)}`);
            setLoading(false);
            return;
        }

        const validateEmails = validateEmail(form.guest_email) && validateEmail(form.host_email) && (form.cc_email ? validateEmail(form.cc_email) : true);
        if (!validateEmails) {
            setEmailErrors({
                hostEmail: !validateEmail(form.host_email),
                guestEmail: !validateEmail(form.guest_email),
                ccEmail: !validateEmail(form.cc_email || '')
            });
            setLoading(false);
            return;
        }

        // Aquí puede realizar la lógica para enviar el formulario
        const citaData = {
            ...form,
            start_date: format(new Date(form.start_date), 'yyyy-MM-dd HH:mm'), //new Date(form.startDate), //.toISOString(),
            end_date: format(new Date(form.end_date), 'yyyy-MM-dd HH:mm'), //new Date(form.endDate) //.toISOString()
            acompanentes: form.acompanantes || []
        };

        try {
            console.log("Datos de la cita a enviar:", citaData);
            const response = await postCita(citaData);
            if (response.success === false) {
                const errorMsg = response.message || 'Error al crear la cita';
                setError(errorMsg);
                Swal.fire({
                    title: 'Error',
                    text: errorMsg,
                    icon: 'error',
                    confirmButtonText: 'Entendido',
                    confirmButtonColor: '#d33'
                });
                setLoading(false);
                return;
            }
            const successMsg = `✅ Cita creada exitosamente para ${form.guest_name}`;
            setSuccess(successMsg);
            Swal.fire({
                title: '¡Éxito!',
                text: successMsg,
                icon: 'success',
                confirmButtonText: 'Aceptar',
                confirmButtonColor: '#3085d6',
                timer: 3000,
                timerProgressBar: true,
                showClass: {
                    popup: 'animate__animated animate__fadeInDown'
                },
                hideClass: {
                    popup: 'animate__animated animate__fadeOutUp'
                }
            });
            resetForm();
        } catch (error: any) {
            console.error("Error al crear la cita inicial o crudo:", error, typeof error);
            console.error(error);
            setError(`Error al crear la cita: ${error.message}`);
            Swal.fire('Error', error.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const checkImpersonation = async () => {
            try {
                const hasPermission = true; // Aquí debería implementar la lógica para verificar si el usuario tiene permiso para impersonar
                setCanImpersonate(hasPermission);
            } catch (error) {
                console.error("Error al verificar la impersonisación:", error);
            } finally {
                setLoading(false);
            }
        }
        if (user) checkImpersonation();
    }, [user]);



    useEffect(() => {
        const loadOfficeLocation = async () => {
            if (!impersonar && user?.User.email) {
                try {
                    const users = await fetchUsers(user.User.email);
                    if (users.length > 0) {
                        const userData = users[0];
                        setForm(prev => ({
                            ...prev,
                            office_Location: userData.officeLocation || "", // Asigna la ubicación si está disponible
                        }));
                    }
                } catch (error) {
                    console.log("Error al cargar la ubicación de la oficina:", error);
                }
            }
        };
        loadOfficeLocation();
    }, [impersonar, user?.User.email]);



    const handleImpersonationToggle = (checked: boolean) => {
        setImpersonar(checked);
        if (!checked) {
            //Al desactivar la impersonación, restablece al usuario actual
            setForm(prev => ({
                ...prev,
                host_email: user?.User.email || "",
                office_Location: '' //Se cargar automaticamente en el useEffect 
            }));
            setShowUserSearch(false);
        } else {
            //Al activar impersonación, limpia el campo y muestra el buscador
            setForm(prev => ({
                ...prev,
                host_email: '',
                office_Location: ''
            }));
            setShowUserSearch(true);
        }
    };

    // Función de validación
    const validateEmail = (email: string) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    };

    // Manejador modificado para guestEmail
    const handleGuestEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setForm(prev => ({ ...prev, guest_email: value }));
        setEmailErrors(prev => ({ ...prev, guest_email: !validateEmail(value) }));
    };

    // Manejador modificado para guestEmail
    const handleCcEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setForm(prev => ({ ...prev, cc_email: value }));
        setEmailErrors(prev => ({ ...prev, cc_email: !validateEmail(value) }));
    };

    // Manejador modificado para HostEmail
    /* const handleHostEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setForm(prev => ({ ...prev, host_email: value }));
        setEmailErrors(prev => ({ ...prev, host_email: !validateEmail(value) }));
    }; */

    const loadBuildings = async () => {
        setLoadingEdificios(true);
        try {
            const edificios = await fetchBuildings();
            setBuildings(edificios.filter(b => b.is_active));
        } catch (error: any) {
            setError(error.message || 'Error al cargar edificios')
        } finally {
            setLoadingEdificios(false);
        }
    }

    useEffect(() => {
        loadBuildings();
    }, []);

    const limpiarSeleccionPersona = () => {
        setForm(prev => ({
            ...prev,
            guest_cedula: '',
            guest_name: '',
            guest_email: ''
        }));
        setPersonaVetada({ vetado: false });
        setError(null);
    };


    return (
        <div className="container mt-3">
            <h4 className="mb-3">Agendar Visita</h4>
            {success && (
                <div className="alert alert-success alert-dismissible fade show" role="alert">
                    <i className="fas fa-check-circle me-2"></i>
                    {success}
                    <button type="button" className="btn-close" onClick={() => setSuccess(null)}></button>
                </div>
            )}
            {/* <div className="row mb-3 d-flex align-items-center"> */}
            {/* Formulario */}
            <form onSubmit={handleSubmit}>
                {/* Checkbox Impersonar*/}
                <div className="card shadow-sm mb-3">
                    <div className="card-header bg-light py-2">
                        <h6 className="mb-0">
                            <i className="bi-person-badge me-2"></i>
                            Anfitrion y Ubicación
                        </h6>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-4 mb-2">
                                <div className="d-flex align-items-center mb-2">
                                    <label htmlFor="hostEmail" className="form-label small mb-0 me-2 flex-grow-1 ">
                                        Anfitrión
                                    </label>
                                    {canImpersonate && (
                                        <div className="form-check form-switch">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="impersonar"
                                                checked={impersonar}
                                                onChange={(e) => handleImpersonationToggle(e.target.checked)}
                                            />
                                            <label className="form-check-label small" htmlFor="impersonar" title="Crear una cita en nombre de otro usuario">
                                                <small>En nombre de</small>
                                            </label>
                                        </div>
                                    )}
                                </div>
                                {showUserSearch ? (
                                    // Mostrar buscador cuando está en modo impersonación
                                    <UserSearch
                                        onUserSelect={handleUserSelect}
                                    />
                                ) : (
                                    // Mostrar input normal cuando NO está en modo impersonación
                                    <input
                                        type="email"
                                        className={`form-control form-control-sm ${emailErrors.hostEmail ? 'is-invalid' : ''}`}
                                        id="hostEmail"
                                        value={form.host_email}
                                        readOnly /* ={!impersonar} */
                                        // onChange={handleHostEmailChange}
                                        style={{ backgroundColor: impersonar ? "#f8f9fa" : "#e9ecef" }}
                                    />
                                )}
                                {/* Mostrar ubicación de la oficina */}
                                {form.office_Location && (
                                    <small className="text-muted d-block mt-1">
                                        <i className="bi-geo-alt me-1"></i>{form.office_Location}
                                    </small>
                                )}
                            </div>
                            <div className="col-md-4 mb-2">
                                <label htmlFor="building_id" className="form-label small">Edificio</label>
                                <select
                                    className="form-select form-select-sm"
                                    id="building_id"
                                    value={form.building_id?.toString() || ''}
                                    onChange={(e) => setForm({ ...form, building_id: e.target.value ? parseInt(e.target.value) : null })}
                                    required
                                >
                                    <option value="" className="text-muted">Seleccionar edificio...</option>
                                    {loadingEdificios ? (
                                        <option disabled>Cargando edificios...</option>
                                    ) : (
                                        buildings.map((building) => (
                                            <option key={building.building_id} value={building.building_id}>
                                                {building.building_name}
                                            </option>
                                        ))
                                    )}
                                </select>
                            </div>
                            <div className="col-md-4 mb-2">
                                <label htmlFor="guest_email" className="form-label small">
                                    Con Copia <small>(opcional)</small>
                                    <i
                                        className="bi bi-question-circle ms-1"
                                        style={{ cursor: 'help' }}
                                        title="Si deseas que otra persona reciba copia de esta cita, ingresa su correo electrónico."
                                    ></i>
                                </label>
                                <input
                                    type="email"
                                    className={`form-control form-control-sm ${emailErrors.ccEmail ? 'is-invalid' : ''}`}
                                    id="cc_email"
                                    value={form.cc_email}
                                    onChange={handleCcEmailChange}
                                // onChange={(e) => setForm({ ...form, guestEmail: e.target.value })}
                                />
                                {emailErrors.ccEmail &&
                                    <div className="invalid-feedback">El email de la copia no es válido.</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="row mb-3">
                    <div className="col-md-6 mb-3">
                        {emailErrors.hostEmail &&
                            <div className="invalid-feedback">El email del anfitrión no es válido.</div>
                        }
                    </div> */}
                {/* <div className="col-md-6 mb-3">
                            <label htmlFor="hostEmail" className="form-label">Email del anfitrión</label>
                        </div> */}
                {/* </div> */}
                {/* Visitante Principal */}
                <div className="card shadow-sm mb-3">
                    <div className="card-header bg-light py-2">
                        <h6 className="mb-0">
                            <i className="bi-calendar-check me-2"></i>
                            Visitante Principal
                        </h6>
                    </div>
                    <div className="card-body">
                        <div className="row g-2">
                            <div className="col-md-4">
                                <label className="form-label small">Cédula</label>
                                {/* <PersonaSearch onPersonaSelect={handlePersonaSelect} value={form.guest_cedula} /> */}
                                <PersonaSearchSQL 
                                    onPersonaSelect={handlePersonaSelectSQL} 
                                    onPersonaNotFound={handlePersonaNotFound}
                                    value={form.guest_cedula}
                                    resetKey={personaSearchResetKey} />
                                {personaVetada.vetado && (
                                    <div className="alert alert-danger mt-2 py-2 small">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                {/* <i className="bi bi-exclamation-triangle-fill me-2"></i> */}
                                                <span><strong>Vetado:</strong> {personaVetada.nombre} ({personaVetada.cedula})</span>
                                            </div>
                                            <button
                                                className="btn btn-sm btn-outline-danger py-0"
                                                onClick={limpiarSeleccionPersona}
                                                title="Limpiar Selección"
                                            >
                                                <i className="bi bi-x"></i>Limpiar
                                            </button>
                                        </div>
                                        {personaVetada.motivo && (
                                            <div className="mt-2">
                                                <div className="mt-1">
                                                    <strong>Motivo:</strong> {personaVetada.motivo}
                                                </div>
                                                {/* <div className="mt-1">
                                                    <strong>Vetado por:</strong> {personaVetada.creadoPor}
                                                </div> */}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="guestName" className="form-label small">Nombre</label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="guestName"
                                    value={form.guest_name}
                                    onChange={(e) => setForm({ ...form, guest_name: e.target.value })}
                                    disabled
                                    style={{ cursor: 'not-allowed' }}
                                />
                                {/* Mostrar estado de validación de veto */}
                                {form.guest_cedula && form.guest_name && error && error.includes('vetado') && (
                                    <div className="alert alert-danger mt-2 py-1 small">
                                        <i className="bi bi-exclamation-triangle-fill me-1"></i>
                                        Esta persona está vetada y no se debe permitir su ingreso a la empresa.
                                    </div>
                                )}
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="guest_email" className="form-label small">Email</label>
                                <input
                                    type="email"
                                    className={`form-control form-control-sm ${emailErrors.guestEmail ? 'is-invalid' : ''}`}
                                    id="guest_email"
                                    value={form.guest_email}
                                    onChange={handleGuestEmailChange}
                                    required
                                // onChange={(e) => setForm({ ...form, guestEmail: e.target.value })}
                                />
                                {emailErrors.guestEmail &&
                                    <div className="invalid-feedback">El email del visitante no es válido.</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {/** Sección de acompañantes Accordion */}
                <div className="card shadow-sm mb-3">
                    <div className="card-header bg-light py-2 d-flex justify-content-between align-items-center"
                        style={{ cursor: 'pointer' }}
                        onClick={() => setAcompanantesOpen(!acompanantesOpen)}
                    >
                        <h6 className="mb-0">
                            <i className="bi bi-people me-2"></i>
                            Acompañantes
                        </h6>
                        <div>
                            <span className="badge bg-primary me-2">
                                {form.acompanantes?.length || 0}
                            </span>
                            <i className={`bi bi-chevron-${acompanantesOpen ? 'up' : 'down'}`}></i>
                        </div>
                    </div>
                    {acompanantesOpen && (
                        <div className="card-body">
                            <AcompanantesModal
                                acompanantes={form.acompanantes || []}
                                onChange={handleAcompanantesChange}
                                maxAcompanantes={10}
                            />
                        </div>
                    )}
                </div>
                {/* Indicaciones */}
                <div className="card-body">
                    <div className={`
                        mb-3
                        position-relative 
                        overflow-hidden 
                        border ${isContentValid ? "border-secondary" : "border-danger"} 
                        rounded 
                        h-250px 
                        bg-light
                        `}
                    >
                        {/* <label htmlFor="indicaciones"
                            className="form-label mb-0 p-2 bg-light w-100">Indicaciones detalladas</label> */}
                        <ReactQuill
                            key={`quill-${resetKey}`}
                            theme="snow"
                            value={form.indications}
                            onChange={handleContentChange}
                            modules={quillModules}
                            formats={quillFormats}
                            placeholder="Escribe las indicaciones aquí..."
                            className="form-control border-0 bg-transparent flex-grow-1"
                            style={{ height: "120px", marginBottom: "40px" }}
                            onFocus={handleIndicationsFocus}
                        />
                        {!isContentValid && form.indications?.trim() !== '' && (
                            <small className="text-danger position-absolute bottom-0  start-50 translate-middle-x mb-1">
                                El contenido debe tener al menos 20 caracteres (actual: {form.indications?.length})
                            </small>
                        )}
                    </div>
                </div>
                {/* Fecha y Hora */}
                <div className="card shadow-sm mb-3">
                    <div className="card-header bg-light py-2">
                        <h6 className="mb-0">Fecha y Hora</h6>
                    </div>
                    <div className="card-body">
                        <div className="row g-2">
                            <div className="col-md-6">
                                <label htmlFor="startDate" className="form-label small">Inicio</label>
                                <input
                                    type="datetime-local"
                                    className="form-control form-control-sm"
                                    id="startDate"
                                    value={form.start_date}
                                    onChange={handleFechaChange}
                                    min={getCurrentDateTimeLocal()} // Establece la fecha mínima como la fecha actual
                                    required
                                />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="endDate" className="form-label small">
                                    Fin
                                </label>
                                <input
                                    type="datetime-local"
                                    className="form-control form-control-sm"
                                    id="endDate"
                                    value={form.end_date}
                                    onChange={handleFechaFinChange}
                                    min={form.start_date ? getMinEndDate(form.start_date) : ''} // Mínimo 1 hora después
                                    required
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {error && <div className="alert alert-danger mt-2">{error}</div>}

                <div className="gap-2 d-flex justify-content-end">
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
                                Creando...
                            </>

                        ) : (
                            <>
                                <i className="bi bi-calendar-plus me-2"></i>Crear Cita
                            </>
                        )}
                    </button>
                    <button type="button" className="btn btn-outline-secondary" onClick={resetForm}>
                        <i className="bi bi-eraser me-2"></i>Limpiar
                    </button>
                </div>
            </form>
             {/* Modal de creación de persona */}
            <CreatePersonaModal
                show={showCreatePersonaModal}
                onHide={() => setShowCreatePersonaModal(false)}
                searchQuery={pendingSearchQuery}
                onPersonaCreada={handlePersonaCreada}
            />
        </div >
    )
}

export default CitaForm;